import {animate, state, style, transition, trigger} from '@angular/animations';

const timiming = '0.3s cubic-bezier(0.35, 0, 0.25, 1)';

export const stretchDownAnimation = trigger('stretchDown', [
  state('close', style({
    opacity: 0,
    height: 0,
  })),
  state('open', style({
    opacity: 1,
    height: '46px'
  })),
  transition('open=>close', [
      animate(timiming)
    ]
  ),
  transition('close=>open', [
      animate(timiming)
    ]
  )
]);
